// Brand lockup — S-check monogram + snagmatic wordmark (Option 1, product teal)
export default function Logo({ height = 32, withWordmark = true, className = '' }) {
  if (!withWordmark) {
    return (
      <svg
        viewBox="0 0 120 120"
        height={height}
        className={className}
        role="img"
        aria-label="Snagmatic"
      >
        <g transform="skewX(-8)" style={{ transformOrigin: '60px 60px' }}>
          <path
            d="M92 26 H46 Q28 26 28 42 Q28 58 46 58 H74 Q92 58 92 74 Q92 90 74 90 H30"
            fill="none" stroke="var(--text-primary)" strokeWidth="15" strokeLinecap="round"
          />
        </g>
        <path
          d="M58 68 L74 88 L106 46"
          fill="none" stroke="var(--accent)" strokeWidth="15"
          strokeLinecap="round" strokeLinejoin="round"
        />
      </svg>
    )
  }

  return (
    <svg
      viewBox="0 0 460 120"
      height={height}
      className={className}
      role="img"
      aria-label="Snagmatic"
    >
      <g transform="translate(2 0)">
        <g transform="skewX(-8)" style={{ transformOrigin: '60px 60px' }}>
          <path
            d="M92 26 H46 Q28 26 28 42 Q28 58 46 58 H74 Q92 58 92 74 Q92 90 74 90 H30"
            fill="none" stroke="var(--text-primary)" strokeWidth="15" strokeLinecap="round"
          />
        </g>
        <path
          d="M58 68 L74 88 L106 46"
          fill="none" stroke="var(--accent)" strokeWidth="15"
          strokeLinecap="round" strokeLinejoin="round"
        />
      </g>
      <text
        x="128" y="79"
        fontFamily="Inter, 'Segoe UI', system-ui, sans-serif"
        fontSize="52" fontWeight="800" fontStyle="italic" letterSpacing="-1"
      >
        <tspan fill="var(--text-primary)">snag</tspan>
        <tspan fill="var(--accent)">matic</tspan>
      </text>
    </svg>
  )
}
